/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum EventType {
  Feed = 'FEED',
  Nutraceutical = 'NUTRACEUTICAL',
  Medication = 'MEDICATION'
}
